import { forwardRef } from "react";
import classNames from "classnames";

// icons
import { CheckIcon } from "components/icons";

import styles from "./Saved.module.scss";

export const Saved = forwardRef<HTMLDivElement, JSX.IntrinsicElements["div"]>(
  ({ className, ...props }, ref) => {
    const savedClasses = classNames(styles["saved-root"], {
      [className]: className,
    });

    return <div ref={ref} className={savedClasses} {...props}>
      <div className={styles["icon"]}>
        <CheckIcon />
      </div>
      <div className={styles["content"]}>
        <p className={styles["details"]}><strong>Changes saved</strong></p>
        <p className={styles["details"]}>Your changes are processing</p>
      </div>
    </div>;
  }
);